import React from 'react'
import './CreateEventInput.css'

export default function CreateEventInput(props) {
    return (
        <div className={`createEventInputWrapper ${props.wrapperClass ? props.wrapperClass : ''}`}>
            {props.deleteButton && <button className='createEventInputDeleteButton' onClick={props.deleteButton}/>}
            <label className='createEventInputLabel' htmlFor={props.id}>{props.label} {props?.required && <sup>*</sup>}</label>
            <input className='createEventInput' type='text' placeholder="Enter event name" id={props.id} value={props.value} onChange={(e) => props.onChange({
                target: {
                    name: props.name,
                    value: e.target.value,
                }
            })}/>
        </div>
    )
}
